export const DEMO_KEYWORDS = [
  {
    id: 1,
    keyword: 'digital marketing',
    type: 'primary',
    createdAt: '2025-01-10T10:00:00Z',
  },
  {
    id: 2,
    keyword: 'SEO',
    type: 'primary',
    createdAt: '2025-01-10T10:05:00Z',
  },
  {
    id: 3,
    keyword: 'content marketing',
    type: 'primary',
    createdAt: '2025-01-10T10:10:00Z',
  },
  {
    id: 4,
    keyword: 'social media marketing',
    type: 'primary',
    createdAt: '2025-01-10T10:15:00Z',
  },
  {
    id: 5,
    keyword: 'paid advertising',
    type: 'primary',
    createdAt: '2025-01-10T10:20:00Z',
  },
  {
    id: 6,
    keyword: 'PPC',
    type: 'secondary',
    createdAt: '2025-01-10T10:25:00Z',
  },
  {
    id: 7,
    keyword: 'web design',
    type: 'primary',
    createdAt: '2025-01-10T10:30:00Z',
  },
  {
    id: 8,
    keyword: 'digital PR',
    type: 'primary',
    createdAt: '2025-01-10T10:35:00Z',
  },
  {
    id: 9,
    keyword: 'link building',
    type: 'secondary',
    createdAt: '2025-01-10T10:40:00Z',
  },
  {
    id: 10,
    keyword: 'technical SEO',
    type: 'secondary',
    createdAt: '2025-01-10T10:45:00Z',
  },
  {
    id: 11,
    keyword: 'local SEO',
    type: 'secondary',
    createdAt: '2025-01-10T10:50:00Z',
  },
  {
    id: 12,
    keyword: 'e-commerce',
    type: 'primary',
    createdAt: '2025-01-10T10:55:00Z',
  },
  {
    id: 13,
    keyword: 'analytics',
    type: 'secondary',
    createdAt: '2025-01-10T11:00:00Z',
  },
  {
    id: 14,
    keyword: 'conversion optimization',
    type: 'secondary',
    createdAt: '2025-01-10T11:05:00Z',
  },
  {
    id: 15,
    keyword: 'email marketing',
    type: 'secondary',
    createdAt: '2025-01-10T11:10:00Z',
  },
  {
    id: 16,
    keyword: 'marketing automation',
    type: 'secondary',
    createdAt: '2025-01-10T11:15:00Z',
  },
  {
    id: 17,
    keyword: 'brand strategy',
    type: 'secondary',
    createdAt: '2025-01-10T11:20:00Z',
  },
  {
    id: 18,
    keyword: 'influencer marketing',
    type: 'secondary',
    createdAt: '2025-01-10T11:25:00Z',
  },
  {
    id: 19,
    keyword: 'video marketing',
    type: 'secondary',
    createdAt: '2025-01-10T11:30:00Z',
  },
  {
    id: 20,
    keyword: 'mobile marketing',
    type: 'secondary',
    createdAt: '2025-01-10T11:35:00Z',
  },
];
